import {
  FETCH_E2E_NOTIFICATIONS,
  FETCH_E2E_NOTIFICATIONS_SUCCESS,
  FETCH_E2E_NOTIFICATIONS_FAILURE,
  UPDATE_E2E_NOTIFICATION_FLAG,
  UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS,
  UPDATE_E2E_NOTIFICATION_FLAG_FAILURE,
} from './types';

import initialState from './initialState';

function e2eHealthcheckReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_E2E_NOTIFICATIONS:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_E2E_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notifications: action.notifications,
      };
    case FETCH_E2E_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case UPDATE_E2E_NOTIFICATION_FLAG:
      return {
        ...state,
        updatingJobIds: [...state.updatingJobIds, action.updateKey],
      };
    case UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS:
      return {
        ...state,
        updatingJobIds: state.updatingJobIds.filter(updateKey => updateKey !== action.updateKey),
        notifications: state.notifications.map(notification =>
          (notification.jobId === action.jobId && notification.schemaType === action.schemaType
            ? { ...notification, errorMsgFlag: action.errorMsgFlag }
            : notification)),
      };
    case UPDATE_E2E_NOTIFICATION_FLAG_FAILURE:
      return {
        ...state,
        updatingJobIds: state.updatingJobIds.filter(updateKey => updateKey !== action.updateKey),
      };
    default:
      return state;
  }
}

export default e2eHealthcheckReducer;
